<template>
  <v-card outlined class="mt-0">
    <v-card-title>
      เพิ่มคาบเรียน (ด้วยตนเอง)
    </v-card-title>
    <v-card-text>
      <v-alert type="warning" text dense class="mb-3">* ระวัง ระบบไม่ได้ตรวจสอบการกำหนดคาบเรียนในช่วงสอบและช่วงนอกภาคการศึกษา *</v-alert>
      <v-alert type="warning" text dense
        v-if="min_gtt_max"
        class="mb-3"
      >
        Error: เวลาจบน้อยกว่าเวลาเริ่ม
      </v-alert>
      <v-alert type="warning" text dense
        v-if="overlapse"
        class="mb-3"
      >
        Error: มีข้อมูลเวลาทับซ้อน
      </v-alert>
      <v-form ref="form">
        <v-row>
          <v-col
            cols="12"
            sm="4"
          >
            <DatePicker
              label="เลือกวันที่"
              v-model="date"
            ></DatePicker>
          </v-col>
          <v-col
            cols="12"
            sm="4"
          >
            <TimePicker
              label="เวลาเริ่ม"
              v-model="start_time"
            ></TimePicker>
          </v-col>
          <v-col
            cols="12"
            sm="4"
          >
            <TimePicker
              label="เวลาจบ"
              v-model="end_time"
            ></TimePicker>
          </v-col>
        </v-row>
        <div class="mt-3">
          <v-btn
            small
            class="primary white--text"
            @click="validate()"
          >เพิ่มข้อมูลลงตารางเวลา</v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import DatePicker from "./DatePicker.vue";
import TimePicker from "./TimePicker.vue";
import * as dayjs from "dayjs";
import { is_set_overlapse } from "./functions.js";

export default {
  name: "TimeSlotAdding",
  data: () => ({
    date: null,
    overlapse: false,
    min_gtt_max: false,
    start_time: "09:00",
    end_time: "12:00",
  }),
  components: {
    DatePicker,
    TimePicker,
  },
  props: {
    current_time_slots: {
      type: Array,
    },
    add_new_time_slot: {
      type: Function,
    },
  },
  methods: {
    //===========================================================
    validate() {
      if (this.$refs.form.validate()) {
        this.check_time_integrity();
      }
    },
    //===========================================================
    // Main Function to calculate time slots and poppulate them
    check_time_integrity() {
      // check if start time is before end time
      if (this.start_time > this.end_time) {
        this.min_gtt_max = true;
        return false;
      }
      //-------------------------------
      // Check if time slot not overlaps
      let all_time_slot = this.current_time_slots;
      const ret_time_slot = {
        start_date_time: dayjs(
          this.date + " " + this.start_time,
          "YYYY-MM-DD HH:mm"
        ),
        end_date_time: dayjs(
          this.date + " " + this.end_time,
          "YYYY-MM-DD HH:mm"
        ),
      };

      console.log(ret_time_slot);

      all_time_slot = [...all_time_slot, ret_time_slot];
      if (is_set_overlapse(all_time_slot)) {
        this.overlapse = true;
        return false;
      }
      //-----------------------------
      this.overlapse = false;
      this.min_gtt_max = false;
      this.add_new_time_slot([ret_time_slot]);
      this.$refs.form.reset();
      return true;
    },
    //===========================================================
    //===========================================================
  },
};
</script>
